export default __webpack_public_path__ + "static/media/right-leaves.a6840c30.png";